import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  alert: {
    padding: '0.5rem 0.75rem',
    display: 'flex',
    gap: '0.25rem',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[80],
    borderRadius: '0.25rem',
    backgroundColor: neutral[10],
  },
  icon: {
    marginTop: '0.125rem',
    fontSize: '1.25rem',
  },
  message: {
    '& > strong': {
      fontWeight: 600,
    },
  },
});
